<template lang="pug">
  app-modal.modalOneroso(
    :titulo="titulo",
    @closeModal="closeModal()",
    :width="1000",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      p.emptyHistory(v-if="!historicoList || historicoList.length === 0") Não há dados.
      el-steps.steps(:active="activeStep")
        el-step(
          v-for="(historico, index) in historicoList",
          :title="constroiTitulo(index)",
          status="finish"
          :key="historico.actionTime + historico.setor"
          @click.native="clickHistorico(index)",
          :class="{'active': activeStep === index}"
        )
          template(slot="icon")
            img(:src="selectIcon(historico.setor)")
      div
        span.titulo {{acao.titulo}}
        span.descricao {{acao.descricao}}
    template(slot="footer")
      el-button.float-right(type="primary", @click="downloadPdf" v-if="historicoList && historicoList.length > 0")
        | Gerar Espelho do Processo
</template>

<script>
import AppModal from '@/components/AppModal'
import moment from 'moment'
import { mapActions } from 'vuex'
const { setores, nomesSetores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  components: {
    AppModal
  },

  props: {
    historicoList: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      default: '-'
    },
    idProcesso: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      acao: {
        titulo: '-',
        descricao: '-'
      },
      activeStep: 0
    }
  },

  mounted () {
    if (this.historicoList && this.historicoList.length > 0) {
      this.clickHistorico(this.historicoList.length - 1)
    }
  },

  methods: {
    ...mapActions({
      gerarEspelhoProcesso: 'processos/gerarEspelhoProcesso'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    constroiTitulo (index) {
      moment.locale('pt-br')
      const mes = moment.monthsShort('-MMM-', this.historicoList[index].mes - 1)

      return mes + '/' + this.historicoList[index].ano
    },
    clickHistorico (index) {
      this.activeStep = index
      this.acao.titulo = setores[this.historicoList[index].setor] + ' - ' + nomesSetores[this.historicoList[index].setor]
      this.acao.descricao = this.historicoList[index].actionTime + ': ' + this.historicoList[index].actionName
    },
    selectIcon (setor) {
      return require('@/assets/icons/iconesHistoricoProcesso/' + setor + '.png')
    },
    downloadPdf () {
      this.gerarEspelhoProcesso(this.idProcesso)
    }
  }
}
</script>

<style lang="scss" scoped>

@import "@/assets/styles/_variables.scss";

.margin-left {
  margin-left: 5px;
}
.steps {
  padding: 20px;
  padding-top:120px;
  margin-left: 30px;
  margin-right: 30px;
  overflow-x: auto;
  max-width: 100%;
}
.emptyHistory {
  text-align: center;
}

>>> .el-step.is-horizontal .el-step__line {
  height: 4px;
  background-color: $color-primary;
  opacity: 0.5;
}

.titulo {
  display: block;
  color: $color-primary;
  font-size: 23px;
  font-weight: 500;
  margin: 24px 0 24px 24px;
}
.descricao {
  color: #5a5a5a;
  font-weight: 700;
  margin-left: 7%;
  margin-top: 500px;
  font-size: 17px;
}
.float-right {
  float: right;
  margin-right: 5px;
}

>>> .el-step.is-horizontal {
  min-width: 100px;
}

>>> .el-step__icon.is-text {
  border: 0px;
  cursor: pointer;
  align-items: flex-end;
  &:hover {
    border: 1px solid $color-primary;
    border-radius: 20px;
    padding: 0px;
    background-color: $color-primary;
    box-shadow: 0px 0px 10px;
  }
}

>>> .el-step__title.is-finish{
  cursor: pointer;
  position: relative;
  right: 14px;
  color: #5a5a5a;
}

.active {
  >>> .el-step__icon.is-text {
    border: 1px solid $color-primary;
    border-radius: 20px;
    padding: 0px;
    background-color: $color-primary;
    box-shadow: 0px 0px 10px;
  }

  >>> .el-step__title.is-finish {
    color: $color-primary;
  }
}

@media (max-width: 780px) {
  .modalOneroso {
    position: fixed !important;
    width: 410px !important;
  }

  .steps {
    margin-left: 10px;
  }

  .descricao {
    margin-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/AppModalVisualizarHistoricoProcesso.vue